import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './AppIcon';

const Sidebar = ({ collapsed, onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    {
      section: 'Hauptmenü',
      items: [
        { path: '/case-worker-dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
        { path: '/client-search-and-directory', label: 'Klientensuche', icon: 'Search' },
        { path: '/client-profile-management', label: 'Klientenverwaltung', icon: 'Users' },
        { path: '/unique-id-generation-system', label: 'ID-Generierung', icon: 'Hash' }
      ]
    },
    {
      section: 'Operationen',
      items: [
        { path: '/bulk-operations-center', label: 'Massenoperationen', icon: 'Layers' },
        { path: '/supervisor-dashboard-and-analytics', label: 'Supervisor Dashboard', icon: 'BarChart3' }
      ]
    },
    {
      section: 'System',
      items: [
        { path: '/system-administration-panel', label: 'Administration', icon: 'Settings' },
        { path: '/audit-trail-and-compliance-viewer', label: 'Audit & Compliance', icon: 'Shield' },
        { path: '/help-and-documentation-center', label: 'Hilfe & Dokumentation', icon: 'HelpCircle' }
      ]
    }
  ];

  const isActive = (path) => location?.pathname === path;

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <Icon name="Building2" size={24} color="white" />
        </div>
        <div className="sidebar-brand">
          <span className="text-base font-semibold text-foreground">Bundesagentur</span>
          <span className="text-xs text-muted-foreground">für Arbeit</span>
        </div>
      </div>
      <nav className="sidebar-nav">
        {navigationItems?.map((section, idx) => (
          <div key={idx} className="sidebar-section">
            <div className="sidebar-section-title">{section?.section}</div>
            {section?.items?.map((item) => (
              <button
                key={item?.path}
                onClick={() => navigate(item?.path)}
                className={`sidebar-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                <Icon name={item?.icon} size={20} className="sidebar-item-icon" />
                <span className="sidebar-item-text">{item?.label}</span>
              </button>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;